// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"3bda688e","236":"3bda688e","340":"3bda688e","570":"3bda688e","785":"3bda688e"}[chunkId] + ".chunk.css";
};